import { IterableElement } from 'type-fest'

import { ETH_TOKEN_TICKERS } from './token-tickers'
import { Ticker } from '../ticker'

export const ETH_TICKERS = [Ticker.ETH, ...ETH_TOKEN_TICKERS]

export type EthTicker = IterableElement<typeof ETH_TICKERS>
